import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const MagnifyingGlassCVIllustration = ({
  width = 60,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <defs>
        <path id="2y3kwq1awa" d="M0 0.041L24.959 0.041 24.959 25 0 25z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g fill="#FFE6AB">
                <path
                  d="M24.634 35H3.127c-1.347 0-2.44-1.092-2.44-2.439V3.246C.688 1.898 1.78.807 3.128.807h21.507c1.348 0 2.439 1.091 2.439 2.44V32.56c0 1.347-1.091 2.44-2.44 2.44"
                  transform="translate(-1022 -329) translate(1022 328) translate(2) translate(9 5.959)"
                />
              </g>
              <path
                fill="#231F20"
                d="M33.634 6.765H22.758v34.193h10.876c1.348 0 2.439-1.092 2.439-2.439V9.204c0-1.347-1.091-2.439-2.44-2.439"
                opacity=".1"
                transform="translate(-1022 -329) translate(1022 328) translate(2)"
              />
              <path
                fill="#F6F6F6"
                d="M28.271 13.382v-4.22H13.236c-.723 0-1.31.586-1.31 1.31v26.781c0 .723.586 1.31 1.31 1.31H32.28c.723 0 1.31-.587 1.31-1.31V14.48l-.188-.188h-4.22c-.503 0-.91-.407-.91-.909"
                transform="translate(-1022 -329) translate(1022 328) translate(2)"
              />
              <path
                fill="#F6F6F6"
                d="M28.271 13.382v-4.22H13.236c-.723 0-1.31.586-1.31 1.31v26.781c0 .723.586 1.31 1.31 1.31H32.28c.723 0 1.31-.587 1.31-1.31V14.48l-.188-.188h-4.22c-.503 0-.91-.407-.91-.909"
                transform="translate(-1022 -329) translate(1022 328) translate(2)"
              />
              <path
                fill="#9D9D9C"
                d="M28.271 13.382c0 .502.407.91.91.91h4.22l-5.13-5.13v4.22z"
                transform="translate(-1022 -329) translate(1022 328) translate(2)"
              />
              <path
                fill="#000"
                d="M33.401 14.291h-4.22c-.503 0-.91-.407-.91-.909v-4.22h-5.514v29.4h9.522c.724 0 1.31-.586 1.31-1.309V14.478l-.188-.187z"
                opacity=".1"
                transform="translate(-1022 -329) translate(1022 328) translate(2)"
              />
              <path
                fill="#9D9D9C"
                d="M22.235 32.421c-.294.141-.988.314-1.866.314-2.529 0-3.83-1.584-3.83-3.668 0-2.485 1.78-3.862 3.993-3.862.856 0 1.508.174 1.8.315l-.347 1.312c-.325-.14-.792-.27-1.389-.27-1.302 0-2.32.791-2.32 2.42 0 1.453.867 2.375 2.331 2.375.51 0 1.053-.098 1.39-.238l.238 1.302zM25.15 32.627l-2.344-7.313h1.813l.89 3.092c.248.879.477 1.704.65 2.615h.032c.186-.88.413-1.747.663-2.582l.933-3.125h1.758l-2.463 7.313H25.15z"
                transform="translate(-1022 -329) translate(1022 328) translate(2)"
              />
              <g transform="translate(-1022 -329) translate(1022 328) translate(2) translate(0 .959)">
                <mask id="eef29g1reb" fill="#fff">
                  <use xlinkHref="#2y3kwq1awa" />
                </mask>
                <path
                  fill="#878787"
                  d="M22.417 10.444c0 4.326-3.5 7.847-7.803 7.847-4.301 0-7.802-3.52-7.802-7.847s3.501-7.847 7.802-7.847c4.303 0 7.803 3.52 7.803 7.847M.62 21.364c-.827.832-.827 2.18 0 3.013.415.415.956.623 1.498.623.543 0 1.084-.208 1.498-.623l5.256-5.287c1.645 1.108 3.619 1.757 5.742 1.757 5.704 0 10.345-4.667 10.345-10.403 0-5.736-4.641-10.403-10.345-10.403C8.91.041 4.27 4.708 4.27 10.444c0 2.062.607 3.982 1.64 5.6l-5.29 5.32"
                  mask="url(#eef29g1reb)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </DefaultIconWrapper>
);
